import { type HookOptions, type ReturnedValue } from "use-sound/dist/types";
import { useSound as _useSound } from "use-sound?client";

export const useSound = <T = any>(
  src: string | string[],
  options?: HookOptions<T>,
): ReturnedValue => {
  if (import.meta.env.SSR) {
    return [
      () => {},
      { duration: 0, pause: () => {}, stop: () => {}, sound: null },
    ];
  }
  return _useSound(src, options);
};
